export function inFormenScope(record, assignment) {
  return !!assignment && assignment.aktif !== false && (
    (!!record.bolgeId && (assignment.bolgeIds || []).includes(record.bolgeId)) ||
    (!!record.plateId && (assignment.plateIds || []).includes(record.plateId)) ||
    (!!record.plaka && (assignment.plakalar || []).includes(record.plaka))
  );
}

export function canEditShipment(record, { user, personId, manager, canOldDate, formen, assignment, regions, daysAgo }) {
  if (!record || record.durum === 'IPTAL') return false;
  const owner = record.createdBy === user?.email || (!!personId && record.soforId === personId);
  const scopedFormen = formen && assignment?.personelId === personId && inFormenScope(record, assignment);
  if (!manager && !owner && !scopedFormen) return false;
  // Formen editing another driver's trip always respects that trip's regional limit.
  if (canOldDate && (manager || owner)) return true;
  const limit = Number(regions.find(region => region.id === record.bolgeId)?.geriyeDonukGun ?? 2);
  return [record.dolumTarihi || record.sevkTarihi, record.dokumTarihi || record.dolumTarihi || record.sevkTarihi]
    .every(date => { const age = daysAgo(date); return age >= 0 && age <= limit; });
}
